/*
 * AdminConstants
 */

export const GET_MEMBERS_STATISTICS = 'ideal/Admin/GET_MEMBERS_STATISTICS';
export const MEMBERS_STATISTICS_RECEIVED = 'ideal/Admin/MEMBERS_STATISTICS_RECEIVED';

export const SECTIONS_TITLES = {
  TEAM_TITLE: 'Team',
  DASHBOARD_DOUGHNUT_CHART_TITLE: 'Stato dei preventivi',
  ADMIN_WIDGET_TOTAL_QUOTES: 'Contratti totali',
  ADMIN_WIDGET_NEW_CUSTOMERS: 'Nuovi clienti',
  ADMIN_WIDGET_EFFECTIVE_PROFITS: 'Profitto',
};
